// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

//= require jquery3
//= require popper
//= require jquery


import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"
import "../scope_sheet"
import "bootstrap"
console.log("[Pack] application.js loaded");

Rails.start()
ActiveStorage.start()

const EDIT_CREATE_PATH = /\/(new|edit)(\/|$)/;
if (EDIT_CREATE_PATH.test(window.location.pathname)) {
  const warnOnExit = () => console.warn("Heads up: save your progress before leaving this page.");
  window.addEventListener("beforeunload", warnOnExit);
  window.addEventListener("pagehide", warnOnExit);
}
